import LoadingView from "@mittwald/flow-components/dist/components/LoadingView";
import { TranslationProvider } from "@mittwald/flow-components/dist/components/TranslationProvider";
import { UniversalBoundary } from "@mittwald/flow-components/dist/components/UniversalBoundary";
import ErrorReportingContextProvider from "@mittwald/flow-lib/dist/errors/errorReporting/ErrorReportingContextProvider";
import invariant from "invariant";
import type { FC } from "react";
import React, { createElement } from "react";
import WidgetErrorView from "../components/WidgetErrorView";
import config from "../config";
import type WidgetContainer from "./WidgetContainer";

export interface WidgetRendererProps {
  container: WidgetContainer;
  lazyComponents: Record<string, any>;
}

export const WidgetRenderer: FC<WidgetRendererProps> = (props) => {
  const { container, lazyComponents } = props;
  const component = lazyComponents[container.type];

  invariant(
    component !== undefined,
    `Widget ${container.type} is not supported`,
  );

  return (
    <TranslationProvider name={container.type} type="component">
      <ErrorReportingContextProvider tags={{ widget: container.type }}>
        <UniversalBoundary
          errorView={WidgetErrorView}
          loadingView={<LoadingView _height={config.defaultHeight} />}
        >
          {createElement(component.default, container.props)}
        </UniversalBoundary>
      </ErrorReportingContextProvider>
    </TranslationProvider>
  );
};

export default WidgetRenderer;
